import React, { Component,PropTypes } from 'react';
import { Link } from "react-router";
import {ellaUrl} from '../../path.config'
import {getUserId,resultTip,language} from "UTIL/common"
import roleService from 'SERVICES/ella/roleService'
import BoxHeader from "CONFIG/component/boxHeaderCreate"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
export default class RoleDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			roleId: this.props.params.id,
			nodeVos:[],
			permissions:[],
			role:{},
			url:ellaUrl
		};
	}
	componentDidMount() {
		const roleId = this.state.roleId;
        const userId = sessionStorage.getItem("userId");
        roleService.roleToUpdate(roleId,userId).then(data=>{
            var nodeVos = JSON.parse(data.data.nodeVos);
            var permissions = JSON.parse(data.data.permissions);
            var role = data.data.role;
            this.setState({
                nodeVos : nodeVos,
                permissions : permissions,
                role : role,
            })
            var setting = {
                check: {
                    enable: true,

                },
                showLine: true,
            };
            $.fn.zTree.init($("#pageTree"), setting, nodeVos);
            var zTree = $.fn.zTree.getZTreeObj("pageTree");
            //查找需要选中的节点
            var nodes = zTree.getNodesByFilter(function(node){
                for(var i in permissions){
                    var o = permissions[i];
                    if(o != null && o != "" && o['id'] == node.id && o['level'] == node.level){
                        return true;
                    }
                }
            });
            //设置节点为选中状态
            for(var i in nodes){
                zTree.checkNode(nodes[i], true, true, true);
            }
            //展开所有节点
            zTree.expandAll(true);
            var checkedNodes = zTree.getCheckedNodes(true);
            for(var i=0;i<checkedNodes.length;i++){
                zTree.setChkDisabled(checkedNodes[i],true);
            }
            var unChkNodes = zTree.getCheckedNodes(false);
           // zTree.hideNodes(unChkNodes);
		})
	}
	render() {
		const row = this.state.role;
		return (
			<div >
				<ContentHeader nameLg="roleManagement" nameSm="roleDetail"/>
				<section className="content" >
					<div className="box box-primary color-palette-box">
						<BoxHeader name="角色详情"/>
		            	<div className="box-body">
							<div className="box-body">
								<table id="yjcz" className="table table-bordered table-striped dataTable">
									<tbody>
									<tr>
										<td className="fontWeightBig">{language()['roleName']}</td>
										<td className="fontWeightSmall">{row.roleName}</td>
										<td className="fontWeightBig">角色编号</td>
										<td>{row.roleNumber}</td>
									</tr>
									<tr>
										<td className="fontWeightBig">{language()['remark']}</td>
										<td className="fontWeightSmall" colSpan="3">{row.remark}</td>
									</tr>
									<tr>
										<td className="fontWeightBig">权限分配</td>
										<td colSpan="3"><div id="leftTree" className="tree_wrapper" >
											<ul id="pageTree" className="ztree">

											</ul>
										</div></td>
									</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div className="box-footer">
							<div className="col-xs-5 text-center">
							</div>
							<div className="col-xs-1 text-center">
								<Link to={"/ella/role/roleIndex"} className="btn btn-default">返回</Link>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/ella/role/roleDetail.js